import Cookies from 'universal-cookie';
import moment from 'moment';
import config from '../config';
const cookies = new Cookies();

export const modulo = (a, n) => ((a % n) + n) % n;

export const getLookupWitHDefaultValue = ({ lookup, defaultValue }) => {
    let handler = {
        get: function (target, name) {
            return target.hasOwnProperty(name) ? target[name] : defaultValue;
        }
    };
    return new Proxy(lookup, handler);
}

export const getFileType = mimeType => {
    const types = ['image', 'audio', 'video', 'text', 'pdf'];
    let type = 'others';
    types.forEach(t => {
        if (mimeType.includes(t)) type = t;
    });
    return type;
}


export function guid() {
    function _p8(s) {
        let p = (Math.random().toString(16) + "000000000").substr(2, 8);
        return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
    }
    return _p8() + _p8(true) + _p8(true) + _p8();
}


export const uploadFileToS3WithSignedUrl = (url, file) => {
    return new Promise(resolve => {
        const oReq = new XMLHttpRequest();
        oReq.open("PUT", url, true);
        oReq.onload = function (oEvent) {
            resolve(oEvent)
        };
        oReq.send(file);
    })

}

export const checkForHttpPrefix = link => {
    if (link.startsWith("http") || link.startsWith("https")) return link
    else return `https://${link}`
}

export const linkify = str => {
    const urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/ig;
    const matches = str.match(urlPattern);
    const res = str.replace(urlPattern, "{{tobereplaced}}").split('{{tobereplaced}}');
    const linkified = res.slice(1).reduce((acc, el, index) => {
        acc.push(<a className="text-scogoprimary underline" key={`link_${index}`} href={checkForHttpPrefix(matches[index])} rel="noopener noreferrer" target='_blank'>{matches[index]}</a>);
        acc.push(el)
        return acc;
    }, [res[0]]);
    return linkified
}


export const isEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const setJWTToken = ({ token, options }) => {
    cookies.set(`${config.name}-isLogged`, token ? "yes" : "no", { ...options, path: '/' });
    cookies.set(`${config.name}-authorization`, token, { ...options, path: '/' });
}

export const getJWTToken = () => {
    return cookies.get(`${config.name}-authorization`)
}

export const isLogged = () => {
    return cookies.get(`${config.name}-isLogged`) === "yes";
}

export const getRootDomain = () => {
    return window.location.hostname.includes(config.rootDomain) ? `.${config.rootDomain}` : 'localhost';
}

export const convertSecToDays = (sec) => moment.duration(sec, 'seconds').asDays().toFixed(1);
export const convertDaysToSec = (days) => moment.duration(days, 'days').asSeconds().toFixed(1);


export const deepEqual = function (x, y) {
    if (x === y) {
        return true;
    }
    else if ((typeof x == "object" && x != null) && (typeof y == "object" && y != null)) {
        if (Object.keys(x).length !== Object.keys(y).length)
            return false;

        for (var prop in x) {
            if (y.hasOwnProperty(prop)) {
                if (!deepEqual(x[prop], y[prop]))
                    return false;
            }
            else
                return false;
        }

        return true;
    }
    else
        return false;
}
